import type { HDPEComposition, SpecificationListItem } from 'api';
import { Stack } from 'ui';

import { buildHDPECompositionItems } from '../../utils/buildHDPECompositionItems/buildHDPECompositionItems';
import { MaterialBreakdownItem } from '../MaterialBreakdownItem/MaterialBreakdownItem';

export const HDPECompositionBreakdown = ({
  composition,
  instructions,
}: {
  composition: HDPEComposition;
  instructions?: SpecificationListItem[];
}) => {
  const { targetHdpeSection, nonTargetSection } = buildHDPECompositionItems(composition, instructions);

  return (
    <Stack
      data-testid="hdpe-composition-breakdown"
      sx={{
        gap: 2,
      }}
    >
      <div>
        {targetHdpeSection.items.map((item, index) => (
          <MaterialBreakdownItem
            key={`${item.label}-${index}`}
            label={item.label}
            value={item.value}
            highlight={item.highlight}
            variant={item.variant}
            dataTestId={item.dataTestId}
          />
        ))}
      </div>
      <div>
        {nonTargetSection.items.map((item, index) => (
          <MaterialBreakdownItem
            key={`${item.label}-${index}`}
            label={item.label}
            value={item.value}
            highlight={item.highlight}
            variant={item.variant}
            dataTestId={item.dataTestId}
          />
        ))}
      </div>
    </Stack>
  );
};
